<div class="history-block">
  <div class="header">История покупок</div>
  @if (isDataLoaded && HasData) {
  <div class="history-items">
    <div *ngFor="let item of paymentHistory">
      <div class="history-item-date">
        {{item.date | date:'d MMMM': '' :'ru-RU' }}
      </div>
      <div class="history-item">
        <div class="history-item-left">
          @if (item.state == 0) {
          <div class="history-item-name">
            {{item.name}}
          </div>
          <div class="history-item-period">
            Активна с {{item.startDate | date:'shortDate': '' :'ru-RU' }} по
            {{item.endDate | date:'shortDate' : '-0000' :'ru-RU' }}
          </div>
          }
          @if (item.state == 1) {
          <div class="history-item-name-error">
            {{item.name}}
          </div>
          <div class="history-item-period error">
            {{item.reasonText}}
          </div>
          }
        </div>
        @if (item.state == 0) {
        <div class="history-item-right">
          - {{item.paymentSum}} ₽
        </div>
        }
        @if (item.state == 1) {
        <div class="history-item-right error">
          - {{item.paymentSum}} ₽
        </div>
        }
      </div>
    </div>
  </div>
  }
  @if (isDataLoaded && !HasData) {
  <div class="history-items">
    <div class="no-history">Здесь вы сможете увидеть историю покупок, когда оформите подписку X Plus</div>
  </div>
  }
  @if (!isDataLoaded) {
  <div class="history-items">
    <div class="wait"></div>
  </div>
  }
</div>
